export const getAverageValue = (values: number[]) => {
  return values.reduce((acc, value) => acc += value, 0) / values.length;
};
